import {
  MarketingConversationTopic,
  QueueType,
} from "@redotech/redo-marketing-common/conversation/marketing-conversation-definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/**
 * Returns the queue count for every (topic, queueType) combination shown in the
 * recover queue bar, so the UI can surface per-queue counts in a single request
 * instead of one round-trip per queue.
 */
export const getAllQueueCounts = {
  name: "getAllQueueCounts" as const,
  input: z.object({}),
  output: z.object({
    counts: z.array(
      z.object({
        topic: createEnum(MarketingConversationTopic),
        queueType: createEnum(QueueType),
        count: z.number(),
      }),
    ),
  }),
};
